import * as ambassadorWixReviewsV1Review from './reviews-v1-review-reviews.http.js';
import * as ambassadorWixReviewsV1ReviewTypes from './reviews-v1-review-reviews.types.js';
import * as ambassadorWixReviewsV1ReviewUniversalTypes from './reviews-v1-review-reviews.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getReview(): __PublicMethodMetaInfo<
  'GET',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.GetReviewRequest,
  ambassadorWixReviewsV1ReviewTypes.GetReviewRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.GetReviewResponse,
  ambassadorWixReviewsV1ReviewTypes.GetReviewResponse
> {
  const payload = { reviewId: ':reviewId' } as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.getReview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/reviews/{reviewId}',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createReview(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.CreateReviewRequest,
  ambassadorWixReviewsV1ReviewTypes.CreateReviewRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.CreateReviewResponse,
  ambassadorWixReviewsV1ReviewTypes.CreateReviewResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.createReview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/reviews',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateReview(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkCreateReviewRequest,
  ambassadorWixReviewsV1ReviewTypes.BulkCreateReviewRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkCreateReviewResponse,
  ambassadorWixReviewsV1ReviewTypes.BulkCreateReviewResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReviewsV1Review.bulkCreateReview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/reviews/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateReview(): __PublicMethodMetaInfo<
  'PATCH',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.UpdateReviewRequest,
  ambassadorWixReviewsV1ReviewTypes.UpdateReviewRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.UpdateReviewResponse,
  ambassadorWixReviewsV1ReviewTypes.UpdateReviewResponse
> {
  const payload = { review: { id: ':reviewId' } } as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.updateReview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/reviews/{review.id}',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteReview(): __PublicMethodMetaInfo<
  'DELETE',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.DeleteReviewRequest,
  ambassadorWixReviewsV1ReviewTypes.DeleteReviewRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.DeleteReviewResponse,
  ambassadorWixReviewsV1ReviewTypes.DeleteReviewResponse
> {
  const payload = { reviewId: ':reviewId' } as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.deleteReview(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/reviews/{reviewId}',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteReviews(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkDeleteReviewsRequest,
  ambassadorWixReviewsV1ReviewTypes.BulkDeleteReviewsRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkDeleteReviewsResponse,
  ambassadorWixReviewsV1ReviewTypes.BulkDeleteReviewsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReviewsV1Review.bulkDeleteReviews(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/reviews/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReviews(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.QueryReviewsRequest,
  ambassadorWixReviewsV1ReviewTypes.QueryReviewsRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.QueryReviewsResponse,
  ambassadorWixReviewsV1ReviewTypes.QueryReviewsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.queryReviews(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/reviews/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setReply(): __PublicMethodMetaInfo<
  'PATCH',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.SetReplyRequest,
  ambassadorWixReviewsV1ReviewTypes.SetReplyRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.SetReplyResponse,
  ambassadorWixReviewsV1ReviewTypes.SetReplyResponse
> {
  const payload = { reviewId: ':reviewId' } as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.setReply(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/reviews/{reviewId}/reply',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeReply(): __PublicMethodMetaInfo<
  'DELETE',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.RemoveReplyRequest,
  ambassadorWixReviewsV1ReviewTypes.RemoveReplyRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.RemoveReplyResponse,
  ambassadorWixReviewsV1ReviewTypes.RemoveReplyResponse
> {
  const payload = { reviewId: ':reviewId' } as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.removeReply(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/reviews/{reviewId}/reply',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateModerationStatus(): __PublicMethodMetaInfo<
  'PATCH',
  { reviewId: string },
  ambassadorWixReviewsV1ReviewUniversalTypes.UpdateModerationStatusRequest,
  ambassadorWixReviewsV1ReviewTypes.UpdateModerationStatusRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.UpdateModerationStatusResponse,
  ambassadorWixReviewsV1ReviewTypes.UpdateModerationStatusResponse
> {
  const payload = { reviewId: ':reviewId' } as any;

  const getRequestOptions =
    ambassadorWixReviewsV1Review.updateModerationStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/reviews/{reviewId}/moderate',
    pathParams: { reviewId: 'reviewId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateModerationStatus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkUpdateModerationStatusRequest,
  ambassadorWixReviewsV1ReviewTypes.BulkUpdateModerationStatusRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.BulkUpdateModerationStatusResponse,
  ambassadorWixReviewsV1ReviewTypes.BulkUpdateModerationStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReviewsV1Review.bulkUpdateModerationStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/reviews/moderate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countReviews(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReviewsV1ReviewUniversalTypes.CountReviewsRequest,
  ambassadorWixReviewsV1ReviewTypes.CountReviewsRequest,
  ambassadorWixReviewsV1ReviewUniversalTypes.CountReviewsResponse,
  ambassadorWixReviewsV1ReviewTypes.CountReviewsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixReviewsV1Review.countReviews(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/reviews/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Review as ReviewOriginal,
  ReviewContent as ReviewContentOriginal,
  Media as MediaOriginal,
  MediaMediaOneOf as MediaMediaOneOfOriginal,
  Image as ImageOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  Author as AuthorOriginal,
  AuthorType as AuthorTypeOriginal,
  AuthorTypeWithLiterals as AuthorTypeWithLiteralsOriginal,
  Reply as ReplyOriginal,
  Moderation as ModerationOriginal,
  ModerationModerationStatus as ModerationModerationStatusOriginal,
  ModerationModerationStatusWithLiterals as ModerationModerationStatusWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginType as OriginTypeOriginal,
  OriginTypeWithLiterals as OriginTypeWithLiteralsOriginal,
  Source as SourceOriginal,
  SourceSourceTypeOptionsOneOf as SourceSourceTypeOptionsOneOfOriginal,
  SourceType as SourceTypeOriginal,
  SourceTypeWithLiterals as SourceTypeWithLiteralsOriginal,
  ReviewRequestOptions as ReviewRequestOptionsOriginal,
  ReviewPublished as ReviewPublishedOriginal,
  ModerationStatusChanged as ModerationStatusChangedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetReviewRequest as GetReviewRequestOriginal,
  GetReviewResponse as GetReviewResponseOriginal,
  CreateReviewAndContactRequest as CreateReviewAndContactRequestOriginal,
  CreateReviewResponse as CreateReviewResponseOriginal,
  CreateReviewRequest as CreateReviewRequestOriginal,
  BulkCreateReviewRequest as BulkCreateReviewRequestOriginal,
  BulkCreateReviewResponse as BulkCreateReviewResponseOriginal,
  BulkReviewResult as BulkReviewResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  UpdateReviewContentRequest as UpdateReviewContentRequestOriginal,
  UpdateReviewContentResponse as UpdateReviewContentResponseOriginal,
  UpdateReviewRequest as UpdateReviewRequestOriginal,
  UpdateReviewResponse as UpdateReviewResponseOriginal,
  DeleteReviewRequest as DeleteReviewRequestOriginal,
  DeleteReviewResponse as DeleteReviewResponseOriginal,
  BulkDeleteReviewsRequest as BulkDeleteReviewsRequestOriginal,
  BulkDeleteReviewsResponse as BulkDeleteReviewsResponseOriginal,
  QueryReviewsRequest as QueryReviewsRequestOriginal,
  QueryV2 as QueryV2Original,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryReviewsResponse as QueryReviewsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  SetReplyRequest as SetReplyRequestOriginal,
  SetReplyResponse as SetReplyResponseOriginal,
  RemoveReplyRequest as RemoveReplyRequestOriginal,
  RemoveReplyResponse as RemoveReplyResponseOriginal,
  UpdateModerationStatusRequest as UpdateModerationStatusRequestOriginal,
  UpdateModerationStatusRequestModerationStatus as UpdateModerationStatusRequestModerationStatusOriginal,
  UpdateModerationStatusRequestModerationStatusWithLiterals as UpdateModerationStatusRequestModerationStatusWithLiteralsOriginal,
  UpdateModerationStatusResponse as UpdateModerationStatusResponseOriginal,
  BulkUpdateModerationStatusRequest as BulkUpdateModerationStatusRequestOriginal,
  ModerationStatus as ModerationStatusOriginal,
  ModerationStatusWithLiterals as ModerationStatusWithLiteralsOriginal,
  BulkUpdateModerationStatusResponse as BulkUpdateModerationStatusResponseOriginal,
  CountReviewsRequest as CountReviewsRequestOriginal,
  CountReviewsResponse as CountReviewsResponseOriginal,
  CountReviewsApplicationErrors as CountReviewsApplicationErrorsOriginal,
} from './reviews-v1-review-reviews.types.js';
